import axios from 'axios'
import { message } from 'ant-design-vue'
import { getAuthHeaders } from '@/utils/token'
import { handleUnauthorized } from '@/utils/startLogin'
// import Cookies from 'js-cookie'
// axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.withCredentials = true
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: import.meta.env.VITE_API_BASE_URL,
  // 超时
  timeout: 0,
})
// request拦截器
service.interceptors.request.use(
  (config) => {
    Object.assign(config.headers, getAuthHeaders())

    // const token = getToken("quectel_token");
    // const crsfToken = getXCsrfToken();
    // 是否需要设置 token
    // const isToken = (config.headers || {}).isToken === false;
    // const isLogin =
    //   config.url === "/api/v1/auth/login" && config.method === "get";
    // if (isLogin && !isToken) {
    //   config.headers.Authorization = token.replace("bearer", "bearer "); // 单点登录的token
    // }

    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?'
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName]
        var part = encodeURIComponent(propName) + '='
        if (value !== null && typeof value !== 'undefined') {
          if (typeof value === 'object') {
            for (const key of Object.keys(value)) {
              let params = propName + '[' + key + ']'
              var subPart = encodeURIComponent(params) + '='
              url += subPart + encodeURIComponent(value[key]) + '&'
            }
          } else {
            url += part + encodeURIComponent(value) + '&'
          }
        }
      }
      url = url.slice(0, -1)
      config.params = {}
      config.url = url
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    const headers = res.headers
    // 未设置状态码则默认成功状态
    const code = res.status || 200
    // 获取错误信息
    const msg = res.data?.msg || res.data?.message
    if (code === 401) {
      if (!res.config?.skipAuthRedirect) handleUnauthorized()
      const error = new Error(msg || '登录已失效')
      error.response = res
      return Promise.reject(error)
    } else if (code === 500 || code === 502) {
      message.error(msg)
      return Promise.reject(new Error(msg))
    } else if (code === 429 || code === 400) {
      message.error(msg)
      return Promise.reject(code)
    } else if (code === 201 || code === 202 || code === 206) {
      return res
    } else if (
      code !== 200 &&
      code !== 204 &&
      code !== 405 &&
      code !== 40017 &&
      code !== 40016 &&
      code !== 11025
    ) {
      Notification.error({
        title: msg,
      })
      return Promise.reject(msg)
    } else {
      return res.config?.returnFullResponse ? res : res.data
    }
  },
  (error) => {
    if (error.config?.silentError) return Promise.reject(error)
    const response = error.response
    const resp = response?.data
    let msg = resp ? resp.msg || error.message : error.message
    console.log(msg, 'responseresponse')
    if (response?.status) {
      switch (String(response.status)) {
        case '400':
          message.error(msg)
          break
        case '401':
          if (!error.config?.skipAuthRedirect) handleUnauthorized()
          break
        case '403':
          message.error(msg)
          break

        default:
          if (msg === 'Network Error') {
            msg = '网络错误'
          } else if (msg.includes('timeout')) {
            msg = '网络超时'
          } else if (msg.includes('Request failed with status code')) {
            msg = ''
          }
          message.error(msg)
      }
    }
    return Promise.reject(error)
  }
)
// let loginModal = false; // 重复弹出要屏蔽
// const handleResponseError = async (code, message) => {
//   // 需要重新登录
//   if (code === 401) {
//     if (loginModal) {
//       return;
//     }
//     loginModal = true;
//     setTimeout(() => {
//       loginModal = false;
//     }, 5000);
//     let msg = "你的登录凭证已过期，请重新登录";
//     MessageBox.confirm(msg, "重新登录", {
//       closeOnClickModal: false,
//       confirmButtonText: "重新登录",
//       cancelButtonText: "取消",
//       type: "warning",
//     })
//       .then(() => {
//         store.dispatch("LogOut").then(() => {
//           location.href = "/login";
//         });
//       })
//       .catch(() => {});
//   }
// };
export default service
